(function () {
    "use strict";

    angular.module("app").component("habilCurrentNationalities", {
        template: `<div>
                       <habil-multi-select options="$ctrl.nationalities" selection-changed-with-option="$ctrl.OptionChanged">{{'Person_CurrentNationality' | habilTranslation}}</habil-multi-select>

                       <div class="pill-container space-above">
                           <div class="status-pill-green"
                                ng-repeat="Nationality in $ctrl.person.Nationalities"
                                ng-click="$ctrl.Remove(Nationality)"
                                title="{{'Delete' | habilTranslation}}">
                                <span>{{Nationality.NationalityCode | codeValue:$ctrl.nationalities}}</span>
                                <span class="fa fa-times" aria-label="Close"></span>
                           </div>
                       </div>
                   </div>`,
        bindings: {
            person: '=',
            selectionChanged: '=?',
        },
        controller: HabilCurrentNationalitiesController
    });

    HabilCurrentNationalitiesController.$inject = ["$rootScope"];
    function HabilCurrentNationalitiesController($rootScope) {
        const vm = this;
        vm.$onInit = initialize;

        vm.OptionChanged = optionChanged;

        vm.Remove = removeNationalityWithPill;

        function initialize() {
            // Initialize selection list
            vm.nationalities = angular.copy($rootScope.codeCountries);

            // Set Selected to true on items in the selection list for the persons' nationalities
            for (const nationality of vm.person.Nationalities) {
                const nat = vm.nationalities.find(n => n.Key == nationality.NationalityCode);
                nat.Selected = true;
            }
        }

        function executeCallback() {
            if (angular.isFunction(vm.selectionChanged)) {
                vm.selectionChanged(vm.person);
            }
        }

        function optionChanged(nationality) {
            const nat = vm.person.Nationalities.find(n => n.NationalityCode == nationality.Key);

            if (nationality.Selected && !nat) {
                vm.person.Nationalities.push({ PublicId: $rootScope.guid.new(), NationalityCode: nationality.Key });
            }
            else {
                const index = vm.person.Nationalities.indexOf(nat);
                vm.person.Nationalities.splice(index, 1);
            }

            executeCallback();
        }

        function removeNationalityWithPill(nationality) {
            const nat = vm.nationalities.find(c => c.Key == nationality.NationalityCode);
            nat.Selected = false;

            const index = vm.person.Nationalities.indexOf(nationality);
            vm.person.Nationalities.splice(index, 1);

            executeCallback();
        }
    }
})();